import { Route } from 'react-router-dom';
import { REPORT_PERMISSIONS } from '@invento/shared';
import { PermissionGuard } from '@/navigation/guards/permission-guard';
import { lazyNamed } from '../lazy-named';
import { TenantPreviewRouteFrame } from './route-frames';

const ReportsPage = lazyNamed(() => import('@/features/reports'), 'ReportsPage');

export function reportsRoutes() {
  return (
    <Route element={<TenantPreviewRouteFrame />}>
      <Route
        path="reports"
        element={
          <PermissionGuard required={REPORT_PERMISSIONS.READ}>
            <ReportsPage />
          </PermissionGuard>
        }
      />
    </Route>
  );
}
